<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>
            <div>From lead capture and tasks to team management and Exhibitor information, everything is integrated and easy to use.</div>
            <div class="mt-4">Accessed via the Event App or the webapp, your companies can do it all from one login.</div>
        </template>
        <template #content>
            <CmsAndApp :webImage="webImage" :appImage="appImage" />
        </template>
    </HeroSection>
    <WatchThisSpace />
    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />
</template>

<script setup>
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import CmsAndApp from '../../components/Layouts/CmsAndApp.vue';
import Tips from '../../components/Blocks/Tips.vue';
import WorksWith from '../../components/Blocks/WorksWith.vue';
import WatchThisSpace from '../../components/Blocks/WatchThisSpace.vue';
import { getFeaturesByIds } from '../../router/features';

import webImage from '@/images/screenshots/app/theme-1/portal-web.png';
import appImage from '@/images/screenshots/app/theme-1/portal-phone.png';

const tips = [
    'You can give Companies access to the Portal without accessing the rest of the App. This is useful to give them a chance to populate their information before the event launches.',
    'Use the "Task List" to assign tasks to your Companies. This is a great way to get them to populate their information before the event launches, and collect any required documents.',
    'Regularly queue Emails to send to your Companies with overdue or upcoming task deadlines.',
];

const baseFeature = getFeaturesByIds(['companyportals'])[0];
const integrations = getFeaturesByIds(['leadcapture', 'badgesandkiosks', 'eventapp']);
</script>
